var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_c('strong',[_vm._v("Access Denied: Your tenant name is invalid. Try signing out and then sign back in. ")])])])
}]

export { render, staticRenderFns }